import React from 'react'
import Collection from './Collection.json'
import { GLOBAL_PATH_PREFIX } from 'src/constants';


export const itemTypes = [
  {
    label: 'Initiatives/Projects',
    value: 'project'
  },
  {
    label: 'Backlog',
    value: 'backlog'
  },
  {
    label: 'Vendors',
    value: 'vendor'
  },
  {
    label: 'Solutions',
    value: 'solution'
  },
  {
    label: 'Other',
    value: 'other'
  }
];

export const DEFAULT_SUB_COLLECTION = { title: '', custom_attr_1: '' }

export const DEFAULT_SUB_COLLECTIONS = {
  title: '',
  ends_on: null,
  children: [1, 2, 3].map((id) => ({ id, ...DEFAULT_SUB_COLLECTION }))
};

export const LABELS = {
  create_steps_title: ['Build your list to evaluate', 'Customize evaluation factors'],
  create_category: 'Evaluation Category',
  create_title: "Title",
  create_subCollections: "List of items to evaluate",
  create_step2_build: "Saved templates",
  create_examples: "Evaluation Factors Rating Guide (Example)",
  eval_factors_rating_guide: "Evaluation Factors Rating Guide",
  create_step2_hint: 'HINT: Define your scoring detail. Participants will use these factors to rate your items.'
}

export const CUSTOM_ATTR_NA = 'NA';

export const ITEM_CUSTOM_ATTR_OPTIONS = [
  {
    id: 'EstimatedCost',
    text: 'Estimated Cost (Optional)',
    placeholder: 'Estimated Cost (e.g. $50k)',
    value: 'Estimated Cost'
  },
  {
    id: 'LevelOfEffort',
    text: 'Level of Effort (Optional)',
    placeholder: 'Level of Effort (e.g. High, Medium, Low)',
    value: 'Level of Effort'
  },
  {
    id: 'ROI',
    text: 'ROI (Optional)',
    placeholder: 'ROI (e.g. High, Medium, Low)',
    value: 'ROI'
  },
  {
    id: 'NA',
    text: 'N/A',
    placeholder: 'Not applicable',
    value: CUSTOM_ATTR_NA
  }
]

export const DEFAULT_CUSTOM_ATTR_VALUE = ITEM_CUSTOM_ATTR_OPTIONS[0].value;

export const PARTICIPATE_TABS = [
  {
    label: 'Move data centers',
    id: 'move_d_c'
  },
  {
    label: 'Launch Product XYZ',
    id: 'launch_p'
  },
  {
    label: 'Vendor rationalization',
    id: 'vendor_r'
  },
  {
    label: 'Expand to east region',
    id: 'expand'
  },
  {
    label: 'Consolidate data centers',
    id: 'consolidate'
  }
]

export const COLLECTION_ID_KEY = 'collectionId'

export const DFAULT_REDUX_COLLECTION = Collection

export const PRESET_FACTORS = DFAULT_REDUX_COLLECTION.children

export const EXAMPLE_FACTORS = PRESET_FACTORS[0].questions.slice(0, 3)

export const createNewDraftFactor = () => {
  return {
    ...DRAFT_FACTOR,
    // draft factor id starts with _
    id: `_${Math.random().toString(36).substring(8)}`,
    // and is_draft is true
    is_draft: true
  }
}

const DRAFT_FACTOR = {
  title: 'Rating factor title...',
  question_type: 'rating',
  weight: 1,
  description: 'Factor description...',
  responses: [
    {
      title: '0',
      description: 'Negative rating',
      numeric_value: 0,
    },
    {
      title: '1',
      description: 'Lowest rating',
      numeric_value: 1,
    },
    {
      title: '2',
      description: 'Low rating',
      numeric_value: 2,
    },
    {
      title: '3',
      description: 'Medium rating',
      numeric_value: 3,
    },
    {
      title: '4',
      description: 'High rating',
      numeric_value: 4,
    },
    {
      title: '5',
      description: 'Best rating',
      numeric_value: 5,
    }
  ]
}

export const truncText = (text = '', len = 0) =>
  text && text.length > len ? text.substr(0, len) + '...' : text

export const splitText = (text = '', splitter = /[.?!]/g) =>
  text.split(splitter).map((str, idx) => <p key={idx}>{str}</p>)

export const ID_REGEX = /^[\w\d]{8}$/g

export const questionsSortFunc = (a, b) => {
  if (a.title < b.title) return -1
  if (a.title > b.title) return 1
  return 0
}

export const EDIT_PAGES_REGEX = /p\/.*\/edit/

export const NON_OWNER_NOTIFY_ERROR_MSG = 'Only the owner of this collection can edit it'

export const isCollectionOwner = (collection) => {
  if (!collection) return false

  const current_user_is_owner = collection.owner && collection.owner.current_user
  return !!(current_user_is_owner)
}

export const getParticipateURL = (pathname) => {
  const pathArray = pathname.split('/')
  if (!pathArray.length) return ''
  const id = pathArray && pathArray.length > 3 ? pathArray[3] : '';
  return `${GLOBAL_PATH_PREFIX}/p/${id}`;
}

export const MOBILE_VIEW_WIDTH_THREASHOLD = 600
